export enum RelatedSubmissionsLocation {
  DRAFT_ASSESSMENT,
  SUBMITTED_ASSESSMENT,
  DELIVERY,
}
